import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMutation as useRetailerRestrictionsMutation } from "@faire/web-api--source/api/retailer/retailerToken/retailer-restrictions/post-hooks";
import { trackZipCodeProtectionViewBlockedPdpPageView } from "@faire/web-api--source/events/zipCodeProtection/view/viewBlockedPdpPage";
import { IRetailerRestrictionsRequest } from "@faire/web-api--source/indigofair/data/IRetailerRestrictionsRequest";
import React, { useState, Suspense, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { LazyBrandRestrictionModal } from "@faire/retailer/components/Modals/BrandRestrictionModal";
import { LazyQuickAddModal } from "@faire/retailer/features/ProductQuickAddModal/LazyQuickAddModal";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useFaireProtection } from "@faire/retailer/stores/domain/FaireProtection/useFaireProtection";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
var useHasFaireProtections = function(retailerToken, brandToken) {
    var isBrandTokenForbidden = useFaireProtection().isBrandTokenForbidden;
    var hasFaireProtection = useMemo(function() {
        if (!retailerToken || !brandToken || getIsBrandPreview()) {
            return false;
        }
        return isBrandTokenForbidden(brandToken, {
            trackReason: true
        });
    }, [
        brandToken,
        isBrandTokenForbidden,
        retailerToken
    ]);
    return hasFaireProtection;
};
export var ProductModals = function(param) {
    var productToken = param.productToken, brand = param.brand, brandToken = param.brandToken, queryParams = param.queryParams;
    var _restrictions_retailer_restrictions;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var goBack = useHistory().goBack;
    var _useRetailerRestrictionsMutation = useRetailerRestrictionsMutation(), postRetailerRestrictions = _useRetailerRestrictionsMutation.mutate, restrictions = _useRetailerRestrictionsMutation.data;
    var _useState = _sliced_to_array(useState(false), 2), closeFaireProtectionModal = _useState[0], setCloseFaireProtectionModal = _useState[1];
    useEffect(function() {
        if (retailerToken && brandToken && !getIsBrandPreview()) {
            postRetailerRestrictions([
                retailerToken !== null && retailerToken !== void 0 ? retailerToken : "",
                IRetailerRestrictionsRequest.build({
                    brand_token: brandToken,
                    product_token: productToken
                })
            ]);
        }
    }, [
        brandToken,
        postRetailerRestrictions,
        productToken,
        retailerToken
    ]);
    var hasFaireProtections = useHasFaireProtections(retailerToken, brandToken);
    var onCloseFaireProtectionModal = function() {
        setCloseFaireProtectionModal(true);
        trackZipCodeProtectionViewBlockedPdpPageView(brandToken !== null && brandToken !== void 0 ? brandToken : "", productToken !== null && productToken !== void 0 ? productToken : "");
    };
    var isLoggedInRetailerOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();
    if (!brand) {
        return null;
    }
    if (restrictions !== undefined && ((_restrictions_retailer_restrictions = restrictions.retailer_restrictions) === null || _restrictions_retailer_restrictions === void 0 ? void 0 : _restrictions_retailer_restrictions.length)) {
        var _restrictions_retailer_restrictions1;
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyBrandRestrictionModal, {
                brand: brand,
                origin: "PRODUCT_PAGE",
                retailerRestriction: (restrictions === null || restrictions === void 0 ? void 0 : (_restrictions_retailer_restrictions1 = restrictions.retailer_restrictions) === null || _restrictions_retailer_restrictions1 === void 0 ? void 0 : _restrictions_retailer_restrictions1.length) ? restrictions === null || restrictions === void 0 ? void 0 : restrictions.retailer_restrictions[0] : undefined,
                productToken: productToken
            })
        });
    } else if (hasFaireProtections && !closeFaireProtectionModal) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyBrandRestrictionModal, {
                brand: brand,
                onClose: onCloseFaireProtectionModal
            })
        });
    } else if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("product")) && isLoggedInRetailerOrBrandPreview) {
        var _queryParams_get;
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyQuickAddModal, {
                onClose: function() {
                    return goBack();
                },
                productToken: (_queryParams_get = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("product")) !== null && _queryParams_get !== void 0 ? _queryParams_get : ""
            })
        });
    } else {
        return null;
    }
};
